import { EventSessionDTO } from '@/data/dtos/Events/EventSessionDTO';

export class EventSwimlineDTO {
	constructor(
		public title: string,
		public description: string | null,
		public sessions: EventSessionDTO[],
	) {}
}
